import { TourStep } from './tour.typings'

export const pathStepsMap: { [key: string]: TourStep[] } = {
    'chart': [
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#side-bar-left-buttons',
                    text: `
        <h3><span style="color: #030f28;">Tick2Trade Product Suite</span></h3>
<div>Tick2Trade offers a comprehensive suite of trading tools:</div>
<div>1. Charts&nbsp;</div>
<div>2. Option Chain</div>
<div>3. Strategy Builder</div>
<div>4. Multi-Strike Charts</div>
<div>5. Screener&nbsp;</div>
<div>6. FII-DII Sentiments</div>
    `,
                    textPosition: 'right-start'
                }],
            id: 'chart-step-1'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#stockbar-timebucket-menu-button',
                    text: `
       <p style="color: #030f28; font-size: 1.2em; font-weight: bold; margin-top: 12px; margin-bottom: 12px">Custom Time-Interval</p>
<p style="color: #000000;">Change and set custom time-interval</p>
<p style="color: #1e90ff; font-weight: bold;">Pro-Tip:</p>
<p style="color: #000000;">Get Access to Tick2Trade's <strong>1-Sec Chart</strong> to precisely time your entry and exit.</p>

    `,
                    textPosition: 'bottom-start'
                }],
            id: 'chart-step-2'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#add-alert-menu-button',
                    text: `
        <h3><span style="color: #030f28;">Alerts</span></h3>
<p>Set <span style="color: #1e90ff;"><strong>unlimited alerts</strong> </span>directly from charts and never miss a market move!</p>
    `,
                    textPosition: 'bottom-start'
                }],
            id: 'chart-step-3'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#multipane-menu-open-button',
                    text: `
        <p style="color: #030f28; font-size: 1.2em; font-weight: bold; margin-top: 12px; margin-bottom: 12px">Multi-Pane View</p>
<p>Access saved chart layouts in multi-pane view.</p>
<p style="color: #1e90ff; font-weight: bold;">Pro-Tip:</p>
<p style="color: #000000;">1. Access <strong>Multi-Strike OI and IV Charts</strong> with Candle Charts in multi-pane view.</p>
<p style="color: #000000;">2. Try <strong>Option Trader's Saved Layouts.</strong></p>
    `,
                    textPosition: 'bottom-start'
                }],
            id: 'chart-step-4'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#chart-replay-button',
                    text: `
        <p style="color: #030f28; font-size: 1.2em; font-weight: bold; margin-top: 12px; margin-bottom: 12px">Chart Replay</p>
<p style="color: #000000;">Visually backtest your strategies with Chart Replay.</p>
<p style="color: #1e90ff; font-weight: bold;">Pro-Tip:</p>
<p style="color: #000000;">Also, explore <strong>"Historical (Past Expiry) F&O Data on charts."</strong></p>
    `,
                    textPosition: 'bottom-start'
                }],
            id: 'chart-step-5'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#nav-buttons',
                    text: `
        <h3><span style="color: #030f28;">Option Chain &amp; Multi-Strike Charts</span></h3>
<p>Open Option Chain and Multi-Strike charts for the selected security in a new tab instantly!</p>
    `,
                    textPosition: 'bottom-start'
                }],
            id: 'chart-step-6'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#side-bar-right-options',
                    text: `
        <h3><span style="color: #030f28;">Trader's Tools</span></h3>
<p>The right-nav bar offers quick access to all trader tools:</p>
<div>1. Overview</div>
<div>2. Watchlist</div>
<div>3. Alerts</div>
<div>4. News</div>
<div>5. Trade-Panel</div>
<div>6. Positions</div>
<div>7. Order Book</div>
    `,
                    textPosition: 'right-start'
                }],
            id: 'chart-step-7'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#oi-indicator-menu-button',
                    text: `
        <h3><span style="color: #030f28;">OI Indicators on Candle Charts</h3>
<p>Traders Can Plot OI-Based Indicators Directly on Candle Charts</p>
<ul>
<li><span style="color: #1e90ff;">OI Profile</span> for Deeper Insights</li>
<li><span style="color: #1e90ff;">OI Outlook</span> for Trend Prediction</li>
</ul>
    `,
                    textPosition: 'bottom-start'
                }],
            id: 'chart-step-8'
        },
        {
            elements: [{
                tooltipAlign: 'center',
                selector: '.tour-chart-settings-button',
                text: `<h3><span style="color: #030f28;">Personalize Your Charts</h3>
<p>Customize layout, change widgets, and more by hovering over the bottom of charts and using the&nbsp;Charts tool tip.</p>
<p><span style="color: #1e90ff;"><strong>Change Widget: </strong></span>Traders can Switch between Single or Multi-Pane View, Choosing Candle, OI, and Multi-Strike Charts</p>`,
                textPosition: 'top',
                onEnter: {
                    selector: '.tour-chart-settings-button',
                    type: 'style',
                    value: {
                        opacity: 1
                    }
                }
            }],
            id: 'chart-step-9'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#broker-integration-button',
                    text: `
        <p style="color: #030f28; font-size: 1.2em; font-weight: bold; margin-top: 12px; margin-bottom: 12px">Broker Integration</p>
<p style="color: #000000;">Integrate your broker account seamlessly.</p>
<p style="color: #1e90ff; font-weight: bold;">Pro-Tip:</p>
<p style="color: #000000;">Access <strong>"Paper Trading"</strong> to test your strategies in real-time.</p>
    `,
                    textPosition: 'right-start'
                }],
            id: 'chart-step-10'
        }
    ],
    'multi-strike-chart': [
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#multistrike-top-bar-options',
                    text: `
                            <h3><span style="color: #030f28;">Multi-Strike Toolbar</span></h3>
<p>Traders can select <span style="color: #1E90FF;">Expiry, Multiple Strikes</span>, and time intervals to analyze options' premium, IV, and OI on a single screen.</p>
                        `,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'dashboard-step-1'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#mulstrike-price-options',
                    text: `
                            <h3><span style="color: #030f28;">Multi-Strike OI/IV Toggle</span></h3>
<p>Traders can select <span style="color: #1e90ff;">multiple strikes</span>, adjust time intervals, and quickly toggle between charts displaying <span style="color: #1e90ff;">multi-strike prices, OI, and IV </span>with a simple click.</p>
                        `,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'dashboard-step-2'
        }
    ],
    'screener': [
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#screener-view-type',
                    text: `
                            <h3 style="color: #030f28;">Screener Multi-Chart View</h3>
<p>Easily switch between the tabular view for detailed analysis and the <strong style="color: #1e90ff;">multi-pane chart view</strong> to see candle charts for all screened stocks simultaneously!</p>
`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'dashboard-step-1'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#screen-layout-menu-button',
                    text: `
                            <h3><span style="color: #030f28;">Saved Screens</span></h3>
<p>Quickly access and update your saved screens anytime!!</p>`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'dashboard-step-2'
        }
    ],
    'fii-dii': [
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#poi-header-participants',
                    text: `
                            <h3><span style="color: #030f28;">Choose Participants</span></h3>
<p>Select specific FII/DII participants to tailor your analysis and gain deeper insights into market trends and movements!</p>`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'dashboard-step-1'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#expiry-menu-button',
                    text: `<p style="margin-top: 12px; margin-bottom: 12px">Select months to track <strong style="color: #1e90ff;">FII/DII activity trends</strong> for specific periods.</p>`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'dashboard-step-2'
        }
    ],
    'strategy-builder': [
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#select-strategy-button',
                    text: `<h3><span style="color: #030f28;">Strategy Explorer</span></h3>
<p>Browse, customize, and analyze Options strategies. Open this menu to choose from predefined templates.</p>`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'strategy-builder-step-1'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#short-straddle',
                    text: `<h3><span style="color: #030f28;">Select Strategy</span></h3>
<p>Choose a strategy template to start trading with ease.</p>
<p><span style="color: #1e90ff;"><strong>Pro Tip:</strong></span> Customize your strategy directly from the <span style="color: #1e90ff;"><strong>Payoff Charts</strong></span> to instantly visualize your risk vs. reward. Explore any strategy to learn more!</p>
`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'strategy-builder-step-2'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#strategy-builder-tabs',
                    text: `<h3><span style="color: #030f28;">Builder View Toggle</span></h3>
<p>Switch seamlessly between Payoff Charts, Option Chain, and Strategy Charts.</p>
<p><span style="color: #1e90ff;"><strong>Pro Tip:</strong></span> Discover Tick2Trade’s <span style="color: #1e90ff;"><strong>Strategy Charts</strong></span> for in-depth technical analysis, allowing traders to analyze directly within the strategy setup.</p>
`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'strategy-builder-step-4'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#iv-multiplier-input',
                    text: `<h3><span style="color: #030f28;">IV Change vs P&L</span></h3>
<p>See the effect of Implied Volatility (IV) changes on your option strategy directly in the Payoff Chart. Adjust IV from 0x to 2x to observe real-time shifts in potential P&amp;L.</p>
`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'strategy-builder-step-5'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#target-day-container',
                    text: `<h3><span style="color: #030f28;">Days to Expiry vs P&L</span></h3>
<p>Explore the impact of time decay on your option strategy. Adjust the days to expiry to observe real-time changes in P&amp;L as expiration nears.</p>
`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'strategy-builder-step-6'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#strategy-parameters',
                    text: `<h3><span style="color: #030f28;">Adjust Strategy Parameters</span></h3>
<p>Effortlessly tailor your strategy in the Strategy Builder&mdash;adjust expiries, strikes, quantities, or swap options directly from the trade panel, without returning to the option chain.</p>
`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'strategy-builder-step-7'
        },
        {
            elements: [
                {
                    tooltipAlign: 'center',
                    selector: '#drag-adjustment-0',
                    text: `<h3><span style="color: #030f28;">Adjust Strikes</span></h3>
<p>Effortlessly adjust strikes on the pay-off charts by dragging them directly in your strategy.</p>`,
                    textPosition: 'bottom-start'
                }
            ],
            id: 'strategy-builder-step-8'
        }
    ]
}

export default pathStepsMap
